import Text from 'components/shared/Text'
import Icon from 'components/shared/Icon'
import { formatPrice } from 'helpers/helpers'
import { SummaryPriceButton } from 'components/global/Header/styles'
import { useAppSelector } from 'store/hooks'
import { useApp } from 'store/steps'

interface MobileSummaryProps {
    onClick?: () => void
}

const SummaryPrice = ({ onClick }: MobileSummaryProps) => {
    const { appMode } = useApp()
    const { cart } = useAppSelector((state) => state.cart)
    const { totalPrice: creatorTotalPrice } = cart || {}
    const { totalPrice: selfcareTotalPrice } = useAppSelector(
        (state) => state.selfcareCart
    )

    const totalPrice = () => {
        if (appMode !== 'selfcare') {
            if (creatorTotalPrice === undefined) return '-'

            if (creatorTotalPrice === 0) {
                return 0
            } else if (creatorTotalPrice > 0) {
                return formatPrice(creatorTotalPrice)
            } else {
                return '-'
            }
        } else {
            return formatPrice(selfcareTotalPrice || 0)
        }
    }

    const handleOnClick = () => {
        onClick && onClick()
    }

    return totalPrice ? (
        <SummaryPriceButton
            gap={4}
            direction="row"
            align="center"
            onClick={handleOnClick}
        >
            <Text variant="bodyStrong" color="secondary_500">
                {totalPrice()}
            </Text>
            <Text variant="bodyExtraSmallStrong" color="secondary_500">
                PLN
            </Text>
            <Icon variant="ticket-2" color="secondary_500" />
        </SummaryPriceButton>
    ) : (
        <></>
    )
}
export default SummaryPrice
